var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeviceTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,25 L97,25 C101.418278,25 105,28.581722 105,33 L105,72 C105,76.418278 101.418278,80 97,80 L24,80 C19.581722,80 16,76.418278 16,72 L16,33 C16,28.581722 19.581722,25 24,25 Z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    x2: 60,
    y1: 80,
    y2: 95
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    x2: 80,
    y1: 95,
    y2: 95
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceTv);
export default __webpack_public_path__ + "static/media/device-tv.104a57add9fc7d4bf7786e7875308769.svg";
export { ForwardRef as ReactComponent };